const MOBILE_BREAKPOINT = 920;

export { MOBILE_BREAKPOINT };
